import { toast } from "react-toastify";
import baseApi from "../../../API/baseApi";
import routes from "../../../API/routes";

export async function listarHistoricoImportacao(filtros) {
    try {
        const response = await baseApi.get(`${routes.importacao.listarHistorico}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar o histórico de importações');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar o histórico de importações');
        return null;
    }
}

export async function exportarHistoricoImportacao(cpf) {
    try {
        const response = await baseApi.get(`${routes.importacao.exportarHistorico}`, { cpf: cpf }, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `historico-importacao-${cpf}.xlsx`);
            document.body.appendChild(link);
            link.click();

            toast.success('Histórico exportado com sucesso.');
            return { sucesso: true };
        }else {
            toast.error(response.data.message || 'Ocorreu um erro ao exportar o histórico de importação');
            return { sucesso: false, mensagem: response.data.message || 'Ocorreu um erro ao exportar o histórico de importação' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao exportar o histórico de importação');
        return { sucesso: false, mensagem: errorMessage || 'Ocorreu um erro ao exportar o histórico de importação' };
    }
}

export async function importarArquivos(cpf, files, progressFunction) {
    try {
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: progressFunction,
        };

        let formData = new FormData();

        if (cpf) formData.append("cpf", cpf);

        files.map((file) => formData.append("File[]", file));

        const response = await baseApi.post(`${routes.importacao.importar}`, formData, config);

        if(response.data.success){
            toast.success(response.data.message || 'Upload de arquivos iniciado com sucesso.');
            return { sucesso: true };
        }else{                
            toast.error(response.data.message || 'Ocorreu um erro ao importar os arquivos.');
            return { sucesso: false, mensagem: response.data.message || 'Ocorreu um erro ao importar os arquivos.' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao importar os arquivos.');
        return { sucesso: false, mensagem: errorMessage || 'Ocorreu um erro ao importar os arquivos.' };
    }
}

export async function getPlanilhaCNIS(cpf) {
    try {
        const route = routes.importacao.planilhaCnis;
        const response = await baseApi.get(`${route}?cpf=${cpf}`, null, {
          responseType: "blob",
        });
    
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "planilha-CNIS.xlsx");
        document.body.appendChild(link);
        link.click();
      } catch {}
}

export async function getPlanilhaFontesPagadoras(cpf) {
    try {
        const route = routes.importacao.planilhaFontesPagadoras;
        const response = await baseApi.get(`${route}?cpf=${cpf}`, null, {
          responseType: "blob",
        });
    
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "planilha-fontes-pagadoras.xlsx");
        document.body.appendChild(link);
        link.click();
      } catch {}
}

